import React from "react";
import { connect } from "react-redux";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { pushMessage } from "../../redux/actions/commonActions";
import { changeUserRole } from "../../redux/actions/profileScreenActions";
import { USER_ROLE_VALUE, ADMINISTRATOR_ROLE_VALUE } from "./constants";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class UserRole extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      role: this.props.role,
      disabled: this.props.disabled
    };
  }

  handleChange = async event => {
    const newRole = event.target.value;
    const { pushMessage, changeUserRole } = this.props;
    this.setState({ disabled: true });
    pushMessage({ type: "info", message: `Changing role to "${capitalizeFirstLetter(newRole)}".` });

    await changeUserRole(this.props.userEmail, newRole);
    const { changeUserRoleApiResponse } = this.props;

    if (changeUserRoleApiResponse === 200) {
      pushMessage({ type: "success", message: "Successfully changed user role." });
      this.setState({ role: newRole, disabled: false });
    } else {
      pushMessage({ type: "error", message: "Failed to change user role." });
      this.setState({ disabled: false });
    }
  };

  render() {
    const { role, disabled } = this.state;

    return (
      <Select value={role} disabled={disabled} onChange={this.handleChange} inputProps={{ "aria-label": "User role" }}>
        <MenuItem value={USER_ROLE_VALUE}>User</MenuItem>
        <MenuItem value={ADMINISTRATOR_ROLE_VALUE}>Administrator</MenuItem>
      </Select>
    );
  }
}

const mapStateToProps = state => {
  return {
    changeUserRoleApiResponse: state.profile.changeUserRoleApiResponse
  };
};

export default connect(
  mapStateToProps,
  { pushMessage, changeUserRole }
)(UserRole);
